export const ORACLE_ERRORS = new Set([
  "0x4ca22af0",
  "0xd743df6a",
  "0x06930594",
  "0x52a1f2a0",
  "0xa6e68d63",
  "0xe7764c9e",
  "0x5796f78a",
  "0x9e198af9",
  "0x336dc9d0",
  "0xd9d1f465",
  "0xece458ec",
  "0x6c2325dc",
  "0x608b5307",
  "0xc30a7bd7",
  "0x2b13aef5",
  "0xb0e86e51",
  "0x8552ff3c",
  "0xec459bc0",
  "0x2bc80f3a",
  // Pyth contract native errors
  "0x025dbdd4", // InsufficientFee
  "0xde2c57fa", // NoFreshUpdate
  "0x14aebe68", // PriceFeedNotFound
  "0x45805f5d", // PriceFeedNotFoundWithinRange
  "0xe60dce71", // InvalidUpdateDataSource
  "0xe69ffece", // InvalidUpdateData
  "0x19abf40e", // StalePrice
  // Euler PythOracle adapter errors
  "0x582013b8", // Errors_PriceZero
  "0x0a1119bf", // Errors_InvalidAnswer
  "0x90a94999", // Errors_Overflow
  "0x8468b61d", // Errors_StalePythPrice
  "0x0365e594", // Errors_ConfidenceTooWide
  "0xa50f7073", // PythOracle_InvalidConfiguration
  "0x7499f3d1", // PythOracle_ConfidenceIntervalTooWide
])

export const ORACLE_GET_QUOTES_HEX = "0x0579e61f" as const
export const ORACLE_GET_QUOTE_HEX = "0xae68676c" as const
